module.exports = __webpack_public_path__ + "static/media/头图-领取新人红包.6a0445f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/头图-领取新人红包.png
// module id = 668
// module chunks = 0